<template>
  <div class="header">
    <div class="header-container">
      <!-- 主菜单 -->
      <div class="main-menu">
        <div v-for="(item, index) in mainMenuItems" :key="index" class="main-menu-item"
          :class="{ active: activeMainMenu === item.route }" @click="selectMainMenu(item)">
          <span class="menu-text">{{ item.name }}</span>
          <div v-if="activeMainMenu === item.route" class="active-line"></div>
        </div>
      </div>
      <!-- 用户信息区域 -->
      <div class="user-section">
        <!-- 通知图标 -->
        <div class="notification-icon">
          <img src="@/assets/images/header/notification-icon.png" alt="通知" width="16" height="16" />
        </div>

        <!-- 消息图标 -->
        <div class="message-icon">
          <img src="@/assets/images/header/message-icon.png" alt="消息" width="16" height="16" />
        </div>

        <!-- 用户信息 -->
        <div class="user-info" @click.stop="toggleUserMenu" ref="userInfoRef">
          <div class="user-avatar">
            <img :src="userinfo.headimage" alt="用户头像" width="35" height="35" v-if="userinfo.headimage" />
            <img src="@/assets/images/header/avatar.png" alt="用户头像" width="35" height="35" v-else />
          </div>
          <span class="user-name">{{ userinfo.name }}</span>
          <div class="dropdown-arrow">
            <img src="@/assets/images/header/dropdown-arrow.png" alt="下拉" width="16" height="16" />
          </div>
          <div class="user-dropdown" v-if="showUserMenu">
            <div class="user-dropdown-item" @click.stop="handleMPopover('退出登录')">退出登录</div>
          </div>
        </div>
      </div>
    </div>
    <Popup :dataVal="popupObj" @popupCell="popupCell"></Popup>
  </div>
</template>

<script>
export default {
  name: "AppHeader",
  props: ["navArr", "index"],
  data() {
    return {
      popupObj: {
        flag: false,
        title: "温馨提示",
        content: "是否对当前账号退出登录操作？",
        btn1: "确认",
        btn2: "取消",
      },
      urls: this.imgurl,
      userinfo: {},
      nav: [],
      navId: null,
      activeMainMenu: '', // 默认选中活动管理
      mainMenuItems: [
        { name: "工作台", route: "" },
        { name: "会员管理", route: "/member" },
        { name: "活动管理", route: "/activity" },
        { name: "集采管理", route: "/procurement" },
        { name: "商城管理", route: "" },
        { name: "财务管理", route: "/financial" },
        { name: "系统设置", route: "/system" },
      ],
      showUserMenu: false,
    };
  },
  mounted() {
    this.activeMainMenu = this.$route.meta.fatherRoute;
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    //点击操作
    handleMPopover(type, item) {
      if (type == "退出登录") {
        this.popupObj.type = "退出登录";
        this.popupObj.flag = true;
      }
    },
    async popupCell(val) {
      if (val.submitFlag) {
        if (this.popupObj.type == "退出登录") {
          this.handleLogout()
        }
      }
      this.popupObj.flag = false;
    },
    async indexGetinfo() {
      let res = await this.$api.indexGetinfo()
      if (res.code == 1) {
        res.data.headimage = res.data.headimage ? this.urls + res.data.headimage : ''
        this.userinfo = res.data

        localStorage.setItem('userinfo', JSON.stringify(this.userinfo))
      }
    },
    toggleUserMenu() {
      this.showUserMenu = !this.showUserMenu;
    },
    handleClickOutside(event) {
      const container = this.$refs.userInfoRef;
      if (!container) return;
      if (!container.contains(event.target)) {
        this.showUserMenu = false;
      }
    },
    handleLogout() {
      try {
        // 清理本地登录状态
        localStorage.removeItem('token');
        localStorage.removeItem('userinfo');
      } catch (e) { console.warn('清理本地登录状态失败', e) }
      this.showUserMenu = false;
      this.$message && this.$message.success && this.$message.success('已退出登录');
      this.$router.push('/login');
    },
    selectMainMenu(item) {

      // this.activeSubMenu = 0; // 重置子菜单选中状态

      // 如果不是活动管理，隐藏子菜单
      if (item.route) {
        this.activeMainMenu = item.route;
        this.$router.push(item.route);
      } else {
        this.$message.info('正在开发中...');
      }
    },
  },
  watch: {
    navArr: {
      handler() { },
      deep: true,
    },
    $route: {
      handler() {
        this.mainMenuItems.forEach((item) => {
          if (this.$route.meta.fatherRoute == item.route) {
            // this.navId = item.id;
            this.activeMainMenu = this.$route.meta.fatherRoute;
          }
        });

        this.indexGetinfo()
      },
      deep: true,
      immediate: true
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  // position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 75px;
  // background: linear-gradient(
  //   45deg,
  //   rgba(90, 97, 113, 1) 0%,
  //   rgba(113, 106, 90, 1) 100%
  // );
  padding-left: 204px;
  z-index: 1000;
  // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}

.user-section {
  display: flex;
  align-items: center;
  gap: 20px;
}

.notification-icon,
.message-icon {
  width: 35px;
  height: 35px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.7);
  }
}

.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 8px;
  transition: background-color 0.2s;
  position: relative;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
}

.user-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 6px;
  min-width: 120px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 6px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
  z-index: 1001;
  overflow: hidden;
}

.user-dropdown-item {
  padding: 10px 12px;
  font-size: 14px;
  color: #333;
  white-space: nowrap;
  transition: background-color 0.2s, color 0.2s;

  &:hover {
    background: #f5f5f5;
    color: #c12e30;
  }
}

.user-avatar {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  overflow: hidden;
  background: #c12e30;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.user-name {
  font-family: Inter, sans-serif;
  font-weight: 300;
  font-size: 14px;
  line-height: 2.57;
  color: #ffffff;
}

.dropdown-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
}

.main-menu {
  padding: 15px 0;
  display: flex;
}

.main-menu-item {
  position: relative;
  padding: 10px;
  margin: 0 10px;
  border-radius: 5px 0px 0px 0px;
  cursor: pointer;
  transition: all 0.2s;

  span {
    display: block;
  }

  &:hover {
    background: rgba(193, 46, 48, 0.05);
  }

  &.active {
    .menu-text {
      color: #fff;
    }
  }
}

.menu-text {
  font-family: Inter, sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.57;
  color: #8b8b8b;
  text-align: center;
  transition: color 0.2s;
}

.active-line {
  position: absolute;
  left: 50%;
  bottom: 0;
  height: 2px;
  width: 30px;
  background: #ffffff;
  transform: translate(-50%, 0);
}

// 响应式设计
@media (max-width: 768px) {
  .header {
    padding: 0 15px;
  }

  .main-menu-item {
    margin: 0 5px;
    padding: 8px;
  }

  .menu-text {
    font-size: 12px;
  }

  .logo-circle {
    width: 50px;
    height: 50px;
  }

  .logo-text {
    font-size: 14px;
  }

  .user-section {
    gap: 15px;
  }

  .notification-icon,
  .message-icon {
    width: 30px;
    height: 30px;
  }

  .user-avatar {
    width: 30px;
    height: 30px;
  }

  .user-name {
    font-size: 12px;
  }
}
</style>